import { Separator } from '@crowdfpl/ui-web/separator';
import { Zap } from 'lucide-react';
import { usePlatformStatistics } from '@/hooks/data/platformStatistics';

type CrowdStatsDividerProps = {
  className?: string;
};

export function CrowdStatsDivider({ className }: CrowdStatsDividerProps) {
  const { data, isLoading } = usePlatformStatistics();

  const managers = isLoading ? '...' : (data?.totalManagers ?? 0).toLocaleString();
  const votes = isLoading ? '...' : (data?.totalPredictions ?? 0).toLocaleString();

  return (
    <div className={className ?? 'relative my-8'} role="status" aria-live="polite">
      <Separator />
      <div className="absolute left-1/2 top-1/2 z-10 inline-flex -translate-x-1/2 -translate-y-1/2 items-center gap-2 whitespace-nowrap rounded-full border border-orange-500/20 bg-gradient-to-r from-orange-500/10 to-red-500/10 bg-background px-3 py-1.5">
        <Zap className="h-4 w-4 flex-shrink-0 text-orange-500" aria-hidden />
        <span className="text-xs font-medium md:text-sm">
          {managers} FPL managers with {votes} votes in the crowd
        </span>
      </div>
    </div>
  );
}
